import Presentation from './presentation'

export default Presentation
